import React, { useState, useEffect, memo } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ReviewsCarousel = memo(function ReviewsCarousel({ title = 'Customer Reviews', subtitle = 'What Our Customers Say?', prefetchedReviews = null }) {
  const [reviews, setReviews] = useState(prefetchedReviews || []);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (prefetchedReviews && prefetchedReviews.length > 0) {
      setReviews(prefetchedReviews);
      return;
    }
    // Only fetch if no pre-fetched data provided
    fetch(`${BACKEND_URL}/api/reviews`)
      .then(res => res.json())
      .then(data => setReviews(data))
      .catch(err => console.error('Error fetching reviews:', err));
  }, [prefetchedReviews]);

  useEffect(() => {
    if (reviews.length === 0) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [reviews]);

  if (reviews.length === 0) return null;

  const current = reviews[currentIndex];

  return (
    <section className="reviews-section" data-testid="reviews-section">
      <div className="container">
        <h1>{title}</h1>
        <h3>{subtitle}</h3>
        <div className="review-card" data-testid="review-card">
          <p className="review-text">{current.text}</p>
          <div className="review-author">@{current.author}</div>
          <div className="review-country">{current.country}</div>
        </div>
        <div className="review-dots">
          {reviews.map((_, idx) => (
            <button
              key={idx}
              className={`review-dot ${idx === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(idx)}
              data-testid={`review-dot-${idx}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
});

export default ReviewsCarousel;
